import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import $ from 'jquery'
import Sidebar_component from './Sidebar_component'

export default function Notification_inbox() {
    const navigate = useNavigate();
    const [listNotification, setListNotification] = useState([]);
    const [totalmessage, setTotalmessage] = useState(0);
    const [unreadCount, setUnreadCount] = useState(0);
    const [showDetailspopup, setShowDetailspopup] = useState(false);
    const [showNoticeDetails, setShowNoticeDetails] = useState('');
    const [showNoticeTitle, setShowNoticeTitle] = useState('');
    const [showCreatedBy, setShowCreatedBy] = useState('');
    const [showCreatedAt, setShowCreatedAt] = useState('');
    const [showPurpose, setShowPurpose] = useState('');
    const [showTrgid, setShowTrgid] = useState('');
    const [showType, setShowType] = useState('');
    const [notificationID, setNotificationID] = useState('');
    const loggedUserId = localStorage.getItem('member_id');
    const [membretype, setMembertype] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    let notificationUnid = '';
    useEffect(() => {
        let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
        const storedPermissions = JSON.parse(localStorage.getItem('user_permissions')) || [];

        const isSuperAdmin = storedPermissions.includes("notification.view_all");

        const trgval = isSuperAdmin
            ? localStorage.getItem('mem_company_id')
            : localStorage.getItem('member_id');

        const adminmember = isSuperAdmin ? "Super Admin" : "Member";

        var obj = {
            trgid: trgval,
            usertype: adminmember
        };
        $.ajax({
            type: 'POST',
            url: 'getAllNotifications.php',
            data: obj,
            cache: false,
            success: function (result) {
                console.log(result)
                try {
                    const parsedResult = result;
                    const total = parsedResult.filter(
                        item => item.is_delete == 0
                    ).length;
                    setTotalmessage(total);
                    if (Array.isArray(parsedResult) && parsedResult.length > 0) {
                        setListNotification(parsedResult);
                        const unread = parsedResult.filter(
                            item => item.is_read == 0
                        ).length;

                        setUnreadCount(unread);
                    } else {
                        showAlert('No notification found.');
                        setListNotification([]); // just in case
                    }
                } catch (e) {
                    showAlert('Failed to load notification data.');
                    setListNotification([]); // fallback to prevent map crash
                }
            },
        });
    }, [])

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    //Script for delete notification------------------------------------
    function deleteForAll(itemunid) {
        notificationUnid = itemunid;
        var msg = 'This action will delete the notification from record. No one can see this notification any more and you cannot restore it in future. Do you really want to delete it from record?'
        openDelAlert(msg);
    }

    function openDelAlert(msg) {
        $('#deletepop').css('display', 'block');
        $('#deletepopalert_text').text(msg);
    }
    function closeDelete() {
        $('#deletepop').css('display', 'none');
        $('#deletepopalert_text').text('');
    }

    function deleteNotiForAll() {
        var obj = {
            unid: notificationUnid
        }
        console.log(obj)

        $.ajax({
            type: 'POST',
            url: 'deleteNotification.php',
            data: obj,
            cache: false,
            success: function (result) {
                closeDelete();
                // ✅ Update state immediately
                setListNotification(prevList =>
                    prevList.filter(item => item.unid != notificationUnid)
                );

            },
        });
    }

    //Script for archive notification------------------------------------
    function delteForusaer(item) {
        setNotificationID(item.id)
        var msg = 'This action will delete the notification from your inbox only. You can see it in archive folder. Other user can see this notification in their inbox. Do you really want to delete it from your inbox?'
        openConfAlert(msg);
    }



    function openConfAlert(msg) {
        $('#confpop').css('display', 'block');
        $('#confalert_text').text(msg);
    }
    function closeConf() {
        $('#confpop').css('display', 'none');
        $('#confalert_text').text('');
    }

    function deleteNotiForUser() {
        var obj = {
            notiid: notificationID,
        }
        console.log(obj)

        $.ajax({
            type: 'POST',
            url: 'changeStatusIsDelelte.php',
            data: obj,
            cache: false,
            success: function (result) {
                closeConf();
                // ✅ Update state immediately
                setListNotification(prevList =>
                    prevList.map(item =>
                        item.id == notificationID
                            ? { ...item, is_delete: 1 }
                            : item
                    )
                );

            },
        });
    }
    //Script for details notification------------------------------------
    function goToNotificationDetails(item) {
        setShowNoticeDetails(item.message);
        setShowNoticeTitle(item.purpose_name);
        setShowCreatedBy(item.creator_name);
        setShowCreatedAt(item.created_at);
        setShowPurpose(item.purpose);
        setShowTrgid(item.target_id);
        setShowType(item.type)
        setNotificationID(item.id)
        setShowDetailspopup(true);
        changeNotificationStatus(item.id);

    }
    function closeDetails() {
        setShowDetailspopup(false);
    }

    function changeNotificationStatus(itemid) {

        var obj = {
            notiid: itemid,
        }
        console.log(obj)

        $.ajax({
            type: 'POST',
            url: 'changeStatusToRead.php',
            data: obj,
            cache: false,
            success: function (result) {
                console.log(result)
                // ✅ Update state immediately
                setListNotification(prevList =>
                    prevList.map(item =>
                        item.id == itemid
                            ? { ...item, is_read: 1 }
                            : item
                    )
                );

            },
        });
    }

    //Script for redirect to target ------------------------------------
    function viewTarget() {
        if (showType == 'goal') {
            localStorage.setItem('goal_id', showTrgid);
            navigate('/goal_details');
        }
        if (showType == 'task') {
            localStorage.setItem('taskid', showTrgid);
            navigate('/task_details');
        }
        if (showType == 'project') {
            localStorage.setItem('selected_project_id', showTrgid);
            localStorage.setItem('selected_project_name', showNoticeTitle);
            localStorage.setItem('initialpage', 'members');
            navigate('/project_details');
        }
    }
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs fullwidth pull_left'>Inbox<span>({totalmessage} total message)</span></h2>
                    <p className='fullwidth pull_left pb-15'>You have {unreadCount} unread message (Archive and Inbox)</p>
                    <Link className='pull_right add_new_pro' to="/archive_notification">Archive</Link>
                </div>

                <section className='vl_dsh_bodypart_section'>
                    <div className='vl_dsh_container'>
                        <div className='vl_dsh_one_row'>
                            <div className='vl_dsh_one_full listrow'>
                                <table>
                                    {listNotification
                                        .filter(item => item.is_delete == 0)
                                        .map((listnotification, index) => {
                                            console.log(index)
                                            const isCreator =
                                                listnotification.creator_id == loggedUserId;

                                            return (
                                                <tr
                                                    key={listnotification.id}
                                                    className={listnotification.is_read == 0 ? "unread-row" : "read-row"}
                                                >
                                                    <td className='pr-40'>{listnotification.title}</td>
                                                    <td className='pr-40'>Created By {listnotification.creator_name}</td>
                                                    <td className='pr-40'>{listnotification.created_at}</td>

                                                    <td className='pr-40'>
                                                        {/* View */}
                                                        <span className='catbtn viewbtn pr-40'>
                                                            <button onClick={() => goToNotificationDetails(listnotification)}>
                                                                <i className='ri-eye-line'></i> View
                                                            </button>
                                                        </span>

                                                        {/* Archive (Delete for Me) */}
                                                        <span className='catbtn viewbtn pr-40'>
                                                            <button title="Archive" onClick={() => delteForusaer(listnotification)}>
                                                                <i className='ri-inbox-archive-fill'></i>
                                                            </button>
                                                        </span>

                                                        {/* Delete For All (Only Creator) */}
                                                        {isCreator && (
                                                            <span className='catbtn viewbtn'>
                                                                <button title=" Delete For All"
                                                                    style={{ backgroundColor: "#d9534f", color: "#fff" }}
                                                                    onClick={() => deleteForAll(listnotification.unid)}
                                                                >
                                                                    <i className='ri-delete-bin-6-line'></i>
                                                                </button>
                                                            </span>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                </table>
                            </div>
                        </div>
                    </div>
                </section>

                {showDetailspopup && (
                    <div className="vl_dsh_popup_details" id="detailsbox">
                        <div className="alertbox_hig large">

                            <div className="alertheader">
                                <h3>{showNoticeTitle}</h3>

                            </div>
                            <div className="contentarea">
                                <p>Notification publish by: {showCreatedBy}</p>
                                <p>Notification publish Date: {showCreatedAt}</p>
                                <p>Type of notification: {showPurpose}</p>
                                <p>{showNoticeDetails}</p>
                            </div>
                            <div className="alert_btns">
                                <button onClick={closeDetails}>Close</button>
                                <button onClick={viewTarget} className='ml-10'>View</button>
                            </div>

                        </div>
                    </div>
                )}
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>

            <div className='vl_dsh_popup' id="confpop">
                <div className='alertbox h200'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="confalert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button className='greenbtn' onClick={deleteNotiForUser}>Yes</button>
                        <button className='ml-10' onClick={closeConf}>No</button>
                    </div>

                </div>
            </div>

            <div className='vl_dsh_popup' id="deletepop">
                <div className='alertbox h200'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="deletepopalert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button className='greenbtn' onClick={deleteNotiForAll}>Yes</button>
                        <button className='ml-10' onClick={closeDelete}>No</button>
                    </div>

                </div>
            </div>
            {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                        <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    )
}
